import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Seo from "../components/Seo";
import { LogOut, LayoutGrid } from "lucide-react";

export default function AdminLayout({ title, children, testid }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/admin");
  };

  return (
    <div className="min-h-screen bg-slate-50" data-testid={testid}>
      <Seo title={`${title} | Admin`} description="Admin panel" path="/admin" noindex />
      <header className="sticky top-0 z-40 bg-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
          <Link to="/admin/dashboard" className="flex items-center gap-2 font-oswald text-lg font-bold" data-testid="admin-home-link">
            <LayoutGrid size={18} className="text-red-500" /> Admin Panel
          </Link>
          <button
            onClick={handleLogout}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-300 hover:text-white transition-colors"
            data-testid="admin-logout"
          >
            <LogOut size={16} /> Logout
          </button>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-6">
        <h1 className="font-oswald text-3xl font-bold tracking-tight text-slate-900 mb-6">{title}</h1>
        {children}
      </main>
    </div>
  );
}
